// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import $ from 'jquery';

import PropTypes from 'prop-types';
import React from 'react';

import ScrollToBottomIcon from 'components/svg/scroll_to_bottom_icon';

export default class ScrollToBottomArrows extends React.PureComponent {
    static propTypes = {
        isScrolling: PropTypes.bool.isRequired,
        atBottom: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired
    };

    render() {
        // only show on mobile
        if ($(window).width() > 768) {
            return null;
        }

        let className = 'post-list__arrows';
        if (this.props.isScrolling && !this.props.atBottom) {
            className += ' scrolling';
        }

        return (
            <div
                className={className}
                onClick={this.props.onClick}
            >
                <ScrollToBottomIcon/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/post_view/scroll_to_bottom_arrows.jsx